"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressAppWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("./components");
var _constants = require("./constants");
var _containers = require("./containers");
var _ApiProvider = require("./containers/ApiProvider");
var _contexts = require("./contexts");
var _notificationContext = require("./contexts/notificationContext");
var _jsxRuntime = require("react/jsx-runtime");
const AddressAppWrapper = props => {
  const {
    configuration: config,
    children
  } = props;
  const configuration = {
    ..._constants.defaultConfig,
    ...config
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ErrorBoundary, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ConfigurationProvider, {
      value: configuration,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Loading, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.FormErrorProvider, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
              team: _testidGenerator.Team.Acquisition,
              project: _constants.PROJECT_NAME,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.I18nContainer, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_notificationContext.NotificationProvider, {
                    children: children
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.AddressAppWrapper = AddressAppWrapper;
//# sourceMappingURL=AddressAppWrapper.js.map